import {
  getDateFromTimestamp,
  getHourFromTimestamp,
} from "helpers/efficeHelpers";
import React from "react";

const EfficeDetailTime = ({ time }) => {
  return (
    <>{`${getDateFromTimestamp(time)} at ${getHourFromTimestamp(time)}`}</>
  );
};

export default EfficeDetailTime;
